"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _group = _interopRequireDefault(require("./_group.js"));
var _has = _interopRequireDefault(require("./_has.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
var _default = exports.default = (0, _group.default)(function (result, value, key) {
  if ((0, _has.default)(result, key)) result[key]++;else result[key] = 1;
});